import React from 'react';
import './Expert.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import { BsFillCheckCircleFill } from "react-icons/bs";
import expertImg from '../../assets/expert.png';
import dentalImg from '../../assets/servicePage/gallery/6.png';

const Expert = () => {
    return (
        <section className='expert-section'>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6">
                        <div className="expert-text">
                            <SectionTitle 
                                subTitle="WHY CHOOSE US"
                                title="💎 Why Choose TRUECARE?"
                                description="Experience exceptional dental care with our expert team and modern facilities"
                            />

                            <ul>
                                <li>
                                    <BsFillCheckCircleFill />
                                    ✅ Expert MDS Specialist
                                </li>
                                <li>
                                    <BsFillCheckCircleFill />
                                    ✅ Advanced Equipment & Hygienic Care
                                </li>
                                <li>
                                    <BsFillCheckCircleFill />
                                    ✅ Student & Family Dental Plans
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="expert-img-grid">
                            <div className="expert-img expert-img-main">
                                <img src={expertImg} alt="expert" />
                            </div>
                            <div className="expert-img expert-img-secondary">
                                <img src={dentalImg} alt="dental care" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Expert;